import { createReducer } from 'typesafe-actions';
import { tabResultAction, tabResultState } from './types';

import {
  GET_SEARCH,
  GET_SEARCH_ERROR,
  GET_SEARCH_SUCCESS,
  GET_RELATED_WORD,
  GET_RELATED_WORD_ERROR,
  GET_RELATED_WORD_SUCCESS,
  GET_POPULAR_KEYWORD,
  GET_POPULAR_KEYWORD_ERROR,
  GET_POPULAR_KEYWORD_SUCCESS,
  GET_WIKI,
  GET_WIKI_ERROR,
  GET_WIKI_SUCCESS,
  SET_IS_MORE_INFO_ATTACHMENT,
  SET_IS_MORE_INFO_IMAGE,
  SET_IS_MORE_INFO_RESULT,
  SET_SEARCH_DATA_NULL,
  GET_SPELL_CHECKER,
  GET_SPELL_CHECKER_SUCCESS,
  GET_SPELL_CHECKER_ERROR,
  GET_SEARCH_IMAGE,
  GET_SEARCH_IMAGE_ERROR,
  GET_SEARCH_IMAGE_SUCCESS,
  GET_SEARCH_ATTACH,
  GET_SEARCH_ATTACH_SUCCESS,
  GET_SEARCH_ATTACH_ERROR
} from './actions';

const initialState: tabResultState = {
  error: null,
  loading: false,
  data: null,

  travel_info: null,
  recommended_info: null,
  course_info: null,

  imageResult: null,
  attachResult: null,

  relatedWord: [],
  popularKeyword: [],
  wikiData: null,
  isMoreInfoAttach: false,
  isMoreInfoImage: false,
  isMoreInfoResult: false,
  spellCheckerData: false,
};

const reducer = createReducer<tabResultState, tabResultAction>(initialState, {
  [GET_SEARCH]: (state) => ({
    ...state,
    error: null,
    loading: true,
    travel_info: null,
    recommended_info: null,
    course_info: null,
  }),
  [GET_SEARCH_SUCCESS]: (state, action) => ({
    ...state,
    error: null,
    loading: false,
    data: action.payload,

    travel_info: action.payload.payload.travel_info || null,
    recommended_info: action.payload.payload.recommended_info || null,
    course_info: action.payload.payload.course_info || null,
  }),
  [GET_SEARCH_ERROR]: (state, action) => ({
    ...state,
    error: action.payload,
    loading: false,
    data: null,
    travel_info: null,
    recommended_info: null,
    course_info: null,
  }),

  [GET_SEARCH_IMAGE]: (state) => ({
    ...state,
    error: null,
    imageResult: null,
  }),
  [GET_SEARCH_IMAGE_SUCCESS]: (state, action) => ({
    ...state,
    error: null,
    imageResult: action.payload.payload,
  }),
  [GET_SEARCH_IMAGE_ERROR]: (state, action) => ({
    ...state,
    error: action.payload,
    imageResult: null,
  }),

  [GET_SEARCH_ATTACH]: (state) => ({
    ...state,
    error: null,
    loading: true,
    attachResult: null,
  }),
  [GET_SEARCH_ATTACH_SUCCESS]: (state, action) => ({
    ...state,
    error: null,
    loading: false,
    attachResult: action.payload.payload,
  }),
  [GET_SEARCH_ATTACH_ERROR]: (state, action) => ({
    ...state,
    error: action.payload,
    loading: false,
    
    attachResult: null,
  }),

  [SET_SEARCH_DATA_NULL]: (state) => ({
    ...state,
    loading: true,
    data: null,
    travel_info: null,
    recommended_info: null,
    course_info: null,
  }),

  [GET_RELATED_WORD]: (state) => ({
    ...state,
    error: null,
  }),
  [GET_RELATED_WORD_SUCCESS]: (state, action) => ({
    ...state,
    error: null,

    relatedWord: action.payload.payload,
  }),
  [GET_RELATED_WORD_ERROR]: (state, action) => ({
    ...state,
    error: action.payload,

    relatedWord: [],
  }),

  [GET_POPULAR_KEYWORD]: (state) => ({
    ...state,
    error: null,
  }),
  [GET_POPULAR_KEYWORD_SUCCESS]: (state, action) => ({
    ...state,
    error: null,

    popularKeyword: action.payload.payload,
  }),
  [GET_POPULAR_KEYWORD_ERROR]: (state, action) => ({
    ...state,
    error: action.payload,

    popularKeyword: [],
  }),

  [GET_WIKI]: (state) => ({
    ...state,
    error: null,
    loading: true,
  }),
  [GET_WIKI_SUCCESS]: (state, action) => ({
    ...state,
    error: null,

    wikiData: action.payload.payload,
  }),
  [GET_WIKI_ERROR]: (state, action) => ({
    ...state,
    error: action.payload,

    wikiData: null,
  }),
  [SET_IS_MORE_INFO_RESULT]: (state, action) => ({
    ...state,
    isMoreInfoResult: action.payload,
  }),
  [SET_IS_MORE_INFO_ATTACHMENT]: (state, action) => ({
    ...state,
    isMoreInfoAttach: action.payload,
  }),
  [SET_IS_MORE_INFO_IMAGE]: (state, action) => ({
    ...state,
    isMoreInfoImage: action.payload,
  }),

  [GET_SPELL_CHECKER]: (state, action) => ({
    ...state,
  }),
  [GET_SPELL_CHECKER_SUCCESS]: (state, action) => ({
    ...state,
    spellCheckerData: action.payload.payload,
  }),
  [GET_SPELL_CHECKER_ERROR]: (state, action) => ({
    ...state,
    spellCheckerData: false,
  }),
});

export default reducer;
